import ENDPOINTS from 'tradera-constants/endpoints';
import { defaultClient as httpClient } from 'tradera-utils/http';

const toInt = n => {
    return Math.round(Number(n)) | 0;
};

const calculateShipping = (length, width, height, weight) => {
    length = toInt(length);
    width = toInt(width);
    height = toInt(height);
    weight = toInt(weight);

    if (!length || !width || !height || !weight) {
        return Promise.reject();
    }

    const params = new URLSearchParams({
        height,
        length,
        weight,
        width
    }).toString();

    return httpClient
        .get(`${ENDPOINTS.SELLING_SHIPPING_CALCULATOR}?${params}`)
        .then(response => response.data);
};

export default { calculateShipping };
